import { createActions } from 'redux-actions';

export default createActions(
  {
    ADD: (mission) => mission,
    REMOVE: (index) => ({ index }),
  },
  { prefix: 'MISSIONS' },
);
